export default __webpack_public_path__ + "static/media/ISCO CLASS-4 EXAM PATTERN 2025.bc801dc9.pdf";